/**
 * Link accessible roles.
 *
 * @public
 * @since 2.0.0
 */
enum LinkAccessibleRole {

	/**
	 * Represents Default (link) ARIA role.
	 * @public
	 */
	Link = "Link",

	/**
	 * Represents the ARIA role "button".
	 * @public
	 */
	Button = "Button",
}

export default LinkAccessibleRole;
